// import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
// import LineChartTooltip from './LineChartTooltip/LineChartTooltip';

function NetRevenueGraph({ netRevenueData }) {
    return (
        <div className="border-[1px] rounded-lg border-[#EAEAEA] w-full min-h-[50vh] p-5 flex flex-col gap-4">
            <div className="chart-data">
                <h1 className="font-urbanist-regular font-semibold text-[16px] leading-6">Net Revenue</h1>
            </div>

            <div className="m-auto">
                <h1 className='font-urbanist-regular font-normal italic text-base text-[#666666]'>Available soon</h1>
            </div>

            {/* <ResponsiveContainer width="100%" height="100%">
                <LineChart
                    data={netRevenueData} 
                    margin={{
                        top: 10,
                        right: 20,
                        bottom: 10,
                        left: 10,
                    }}
                >
                    <XAxis 
                        dataKey="year" 
                        tickLine={false} 
                        tickCount={netRevenueData.length} 
                        tickMargin={15} 
                        type='category' 
                    />

                    <YAxis 
                        tickCount={6} 
                        tickLine={false} 
                        tickMargin={15} 
                        type="number" 
                        domain={[0, 50000]} 
                        width={75}
                    />

                    <Tooltip cursor={{ fill: 'transparent' }} />

                    <Line dot={false} type="monotone" dataKey="revenue" stroke="#82ca9d" />
                </LineChart>
            </ResponsiveContainer> */}
        </div>
    );
}

export default NetRevenueGraph;
